const typesData = [
    // "any",
    "face",
    "person",
    "animal",
    "vehicle",
    "food",
    "furniture",
    "sport",
    "electronics",
    "clothes",
    "kitchen",
];
export default typesData;
export const clothesArr = ["handbag", "tie", "suitcase", "backpack", "umbrella"];
export const furnitureArr = ["chair", "couch", "bed", "toilet"];
export const sportArr = [
    "frisbee",
    "skis",
    "snowboard",
    "sports_ball",
    "kite",
    "baseball_bat",
    "baseball_glove",
    "skateboard",
    "surfboard",
    "tennis_racket",
];
export const kitchenArr = [
    "bottle",
    "dining_table",
    "wine_glass",
    "cup",
    "fork",
    "knife",
    "spoon",
    "bowl",
];

export const electronicsArr = [
    "tv",
    "laptop",
    "mouse",
    "remote",
    "keyboard",
    "cell_phone",
    "microwave",
    "oven",
    "toaster",
    "sink",
    "refrigerator",
];
export const vehicleArr = [
    "bicycle",
    "car",
    "motorcycle",
    "airplane",
    "bus",
    "train",
    "truck",
    "boat",
];
export const foodArr = [
    "banana",
    "apple",
    "sandwich",
    "orange",
    "broccoli",
    "carrot",
    "hot_dog",
    "pizza",
    "donut",
    "cake",
];
export const animalArr = [
    "bird",
    "cat",
    "dog",
    "horse",
    "sheep",
    "cow",
    "elephant",
    "bear",
    "zebra",
    "giraffe",
];